// extracted by mini-css-extract-plugin
export var sliderRange = "_m6-2";
export var sliderRoot = "_m6-0";
export var sliderThumb = "_m6-3";
export var sliderTrack = "_m6-1";